var tw = tw || {};
tw.CulinaryShow = (function () {

	// GLOBALS
    var _log = false,
        baseCategory = 'Top Chef',
		holdData = null,
        initLoadResize = true,
        activeRoute = null,
        host = window.location.host,
        reportType = $("[data-reporttype]").data("reporttype"),
        protocol = (window.location.protocol == 'https') ? 'https' : 'http',
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
		baseUrl = protocol + '://' + host + basePath + '/',
        initUgc = true;

    // TEMPLATES
    var sec2MapContent = $('#sec2MapContent').html(),
        bandwangoTemplate = $('#bandwangoTemplate').html(),
        sec3CardsTemplate = $('#sec3CardTemplate').html(),
        sec5CardsTemplate = $('#sec5CardTemplate').html(),
        sec6CardsTemplate = $('#sec6CardTemplate').html(),
        sec7CardsTemplate = $('#sec7CardTemplate').html(),
        sec9CalloutImgTemplate = $('#sec9CalloutImgTemplate').html()


    var $subpanes = $('.js-subpane'),
        $pane = $('.js-pane'),
        $paneIntro = $('.js-pane-intro'),
        $reportButtons = $('.js-report-button'),
        $subpaneButtons = $('.js-subpane-button'),
        $filterButton = $('.js-filter-button'),
        $map = $('.js-report-map'),
        $intro = $('.js-pane-intro'),
        filterButtonOffset;

	var initializePage = function () {
		// if (_log) console.log('isTouch', isTouch);
		// if (_log) console.log('baseUrl', baseUrl);
		// if (_log) console.log('baseTitle:' + baseTitle);
		// if (_log) console.log('reportType:' + reportType);

		// $("[data-route='" + reportType + "']").addClass('is-active');
		activeRoute = reportType;

		CulinaryBingMap.Map.initializeButtons();
        CulinaryBingMap.Map.updateReportType(reportType);
        tw.CulinaryShowsListings.getAllReportsByRegion();
		// BingMap.Map.updateReportType(reportType);
		// var useHref = '';
		// useHref = basePath

		// var txt = activeRoute,
		// 	href = useHref,
		// 	obj = {
		// 		path: href,
		// 		text: txt
		// 	};

		$('body').on('click', '.js-report-expand', function () {
			var thisId = $(this).data('id');
			var thisIndex = $(this).data('index');
			var thisEpisodeNumber = $(this).data('episode-number');

			if (_log) console.log('.js-report-expand.id:', thisId);
            tw.CulinaryShowsListings.getReportDetails(thisId, thisIndex, thisEpisodeNumber);

            //For Map Card click tracking
            var loc = $(this).data('title');
            tw.Analytics.ga4(baseCategory, 'Map Card Click', loc);
            console.log('Map Card Click - ', baseCategory, 'Map Card Click', loc)

            // $subpanes.removeClass('is-hidden'); //remove later
		});

		$('body').on('click', '.js-reports-filter', function (e) {
            e.preventDefault();
            CulinaryBingMap.Map.softResetMap();   
            
            setTimeout(() => {
                $('.js-map-categories').removeClass('active');
                var toggleValue = $(this).data('toggle');
                $(".js-map-categories[data-category='" + toggleValue + "']").addClass("active");
    
                $(this).parent().toggleClass('active');   
                $('.js-reports-filter').not(this).parent().removeClass('active');
    
                var isChecked = $(this).parent().hasClass('active')
                CulinaryBingMap.Map.togglePushpinCluster(isChecked, toggleValue);      
            }, 100);
		});   

		$('body').on('click', '.js-noreports-btn', function () {
			CulinaryBingMap.Map.softResetMap();
		});   
        
		//opening subpanes
		$subpaneButtons.click(function () {
			//if (_log) console.log('$subpaneButtons.click');
			checkDestination($(this));
		});


        var jsonPath = $("[data-json-file]").data("json-file");
        // var         basePath = $("[data-basepath]").data("basepath");
        // console.log(basePath,'basePath');
		getContent(jsonPath);


		$(window).smartresize(function () {
			if (_log) console.log('smartresize.initLoadResize:', initLoadResize);
			if (!initLoadResize) {
				CulinaryBingMap.Map.trackResize();
			}
			initLoadResize = false;

    	}).resize();        
    }

	/**
	 * (RE)Initialize Map, only called once
	 * Get Counties Shape data before initializing map
	 * */
	var initializeMap = function (report) {
		if (_log) console.log('initializeMap()');
		CulinaryBingMap.Map.initializeMap({
			ReportType: report,
			// CountyData: $("[data-countydata]").data("countydata")
		});
	};

	var getPaneRecords = function () {
		return currentReportPane;
	}

	var openSubpane = function (options) {
		if (_log) console.log('openSubpane.options', options);
		var subpaneId = options.subpane,
			$thisSubpane = $subpanes.filter('[data-subpane="' + subpaneId + '"]');
		if ($thisSubpane.length > 0) {
			closeSubpanes();
			if ($thisSubpane.hasClass('is-hidden')) {
				$thisSubpane.removeClass('is-hidden');
			}
			tw.CulinaryShowsListings.hideReports();
		}
	};
	var resetAllPanes = function () {
		closeSubpanes();
		tw.CulinaryShowsListings.showReports();
	}
	var closeSubpanes = function () {
		$subpanes.addClass('is-hidden');
	}    

	var checkDestination = function (button) {
		//if(_log)console.log("checkDestination: ", button);
		var thisSubpane = button.attr('data-subpane'),
			//optional ID of subpane to return to
			returnTo = button.attr('data-return');

		/* If returnTo is true, get the ID of the last report pane user was on and send them back there */
		if (returnTo === "true") {
			thisSubpane = getPaneRecords();
		}

		//if button does not specify a subpane to open (e.g. subpane back buttons) then show the reports
		if (thisSubpane) {
			openSubpane({
				subpane: thisSubpane,
				returnTo: returnTo
			});
		} else {
			closeSubpanes();
			// CulinaryBingMap.Map.softResetMap();
			// tw.CulinaryShowsListings.showReports();
		}
	}
    /**
     * Get content from local json
     * @param {*} dataPath 
    */
    var getContent = function (dataPath) {
        // if (_log) console.log('getContent()', dataPath);
        $('.js-loader').html('<div class="progress-spinner"></div>');

        var jqxhr = $.getJSON(dataPath, function (data) {
            if (_log) console.log("getContent.data:", data);
                holdData = data;
                processContent(data);
            })
            .fail(function (err) {
                console.error("error:", err);
            });
    }

    


    /**
     * Process content from JSON file
     * @param {*} data 
    */
    var processContent = function (data) {
        // if (_log) console.log('processContent()', data);
        
        if(data.hero) {
            $('.js-hero-video').attr("poster", data.hero.thumbnailImageDesktop)
            $('.js-hero-video source').attr('src', data.hero.videoUrl);
            $('.js-hero-video')[0].load();
            $('.js-hero-video-logo').attr('src', data.hero.logoImage);
            $('.js-video-pause').on('click', function() {
                $('.js-hero-video')[0].pause();
                $('.js-video-pause').addClass('d-none')
                $('.js-video-play').removeClass('d-none')
            });
            $('.js-video-play').on('click', function() {
                $('.js-hero-video')[0].play();
                $('.js-video-play').addClass('d-none')
                $('.js-video-pause').removeClass('d-none')
            });
        }

        if (data.section1) {
            $('.js-section1-heading').html(data.section1.heading);
            $('.js-section1-description').html(data.section1.description);
            $('.js-section1-subHeading').html(data.section1.subHeading);
            $('.js-section1-subHeadingDescription').html(data.section1.subHeadingDescription);
            $('.js-section1-cta').attr('href', data.section1.cta.link);
            $('.js-section1-cta').html(data.section1.cta.text);
        }

        if (data.section2) {
            $('.js-map-heading').html(data.section2.heading);
            $('.js-map-mobile-text').html(data.section2.filterMobileText);
            $('.js-map-desktop-text').html(data.section2.filterDesktopText);
            $('.js-map-toggle-features').html(data.section2.toggleTitle1);
            $('.js-map-toggle-judge').html(data.section2.toggleTitle2);
            $('.js-map-toggle-gem').html(data.section2.toggleTitle3);
            $('.js-map-no-report').html(data.section2.noReportsCtaText);
            $('.js-map-cta-heading').html(data.section2.ctaBlock.heading);
            $('.js-map-cta').html(data.section2.ctaBlock.ctaText);
            $('.js-map-cta').attr('href', data.section2.ctaBlock.ctaUrl);
            $('.js-featured-modal-cta-text').html(data.section2.featuredModalCtaText);

            var compiledMapContentTemplate = Template7.compile(sec2MapContent);
            var sec2MapHtml = compiledMapContentTemplate({"sec2Categories": data.section2.categories});
            $('.js-map-body-categories').html(sec2MapHtml);
        }

        if (data.bandwango) {
            $('.js-bandwango-image').attr({'src': data.bandwango.backgroundImage + '?width=1000&height=800&scale=both&mode=crop'});            
            $('.js-bandwango-heading').html(data.bandwango.heading);
            $('.js-bandwango-description').html(data.bandwango.description);
            $('.js-bandwango-contentHeader').html(data.bandwango.contentHeader);            
            $('.js-bandwango-cta').html(data.bandwango.cta.text);
            $('.js-bandwango-cta').attr('href', data.bandwango.cta.link);

            var compiledBandwangoContentTemplate = Template7.compile(bandwangoTemplate);
            var bandwangoHtml = compiledBandwangoContentTemplate({"bandwangoContent": data.bandwango.contentList});
            $('.js-bandwango-contentList').html(bandwangoHtml);
        }

        if (data.section3) {
            $('.js-section3-heading').html(data.section3.heading);
            // Define Template7 Template HTML
            var compiledCardsTemplate = Template7.compile(sec3CardsTemplate);
            var sec3CardHtml = compiledCardsTemplate({"sec3Cards": data.section3.cards});
            $('.js-culinary-articles-slick').html(sec3CardHtml);
            // Initiate Carousel
            $('.js-culinary-articles-slick').slick({
                infinite: false,
                // slidesToShow: 4.1,
                // slidesToScroll: 1,
                prevArrow: $('.js-culinary-slick-prev'),
                nextArrow: $('.js-culinary-slick-next'),
                variableWidth: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 3.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1800,
                        settings: {
                            slidesToShow: 5.1,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
        }

        if (data.section4) {
            $('.js-5050-heading').html(data.section4.heading);
            $('.js-5050-description').html(data.section4.description);
            $('.js-5050-cta').attr('href', data.section4.cta.url);
            $('.js-5050-cta').html(data.section4.cta.text);
            $('.js-5050-svg').attr('src', data.section4.svgOverlay);
            $('.js-5050-image').attr({
                'src': data.section4.backgroundImage + '?width=700&height=475&scale=both&mode=crop',
                'alt': data.section4.backgroundImageDescription
            });
        }
        
        if (data.section5) {
            $('.js-deals-heading').html(data.section5.heading);
            $('.js-deals-description').html(data.section5.description);
            $('.js-deals-cta').attr('href', data.section5.cta.url);
            $('.js-deals-cta').html(data.section5.cta.text);
            // Define Template7 Template HTML
            var compiledDealCardsTemplate = Template7.compile(sec5CardsTemplate);
            var sec5CardHtml = compiledDealCardsTemplate({"sec5Cards": data.section5.cards});
            $('.js-culinary-deals-carousel').html(sec5CardHtml);

            $('.js-culinary-deals-carousel').slick({
                infinite: false,
                prevArrow: $('.js-culinary-deals-prev'),
                nextArrow: $('.js-culinary-deals-next'),                
                variableWidth: false,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1.25,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3.1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                    
                    
                ]
            });
        }

        if (data.section6) {
            $('.js-experiences-heading').html(data.section6.heading);
            $('.js-experiences-description').html(data.section6.description);
            // Define Template7 Template HTML
            var compiledDealCardsTemplate = Template7.compile(sec6CardsTemplate);
            var sec6CardHtml = compiledDealCardsTemplate({"sec6Cards": data.section6.cards});
            $('.js-culinary-experiences-slick').html(sec6CardHtml);
    
            $('.js-culinary-experiences-slick').slick({
                infinite: false,
                prevArrow: $('.js-culinary-experiences-prev'),
                nextArrow: $('.js-culinary-experiences-next'),
                variableWidth: false,
                mobileFirst: true,
                draggable: false,
                responsive: [
                    {
                        breakpoint: 0,
                        settings: {
                            slidesToShow: 1.1,
                            slidesToScroll: 1,
                            draggable: true,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 1.4,
                            slidesToScroll: 1,
                            draggable: true,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2.1,
                            slidesToScroll: 1,
                            draggable: false,
                        }
                    },
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 2.4,
                            slidesToScroll: 1,
                            draggable: false,
                        }
                    },
                    
                    
                ]
            });
        }

        if (data.section7) {
            $('.js-partners-heading').html(data.section7.heading);
            $('.js-partners-description').html(data.section7.description);
            
            $('.js-partner-featured-logo').attr('src', data.section7.featuredPartnerCard.partnerLogo);
            $('.js-partner-featured-description').html(data.section7.featuredPartnerCard.shortDescription);
            $('.js-partner-featured-cta').attr('href', data.section7.featuredPartnerCard.ctaUrl);
            $('.js-partner-featured-cta-text').html(data.section7.featuredPartnerCard.partnerCardCtaText);
            $('.js-partner-featured-name').attr('data-partner-name', data.section7.featuredPartnerCard.partnerName);
            
            $('.js-featured-modal-image').attr('src', data.section7.featuredPartnerCard.partnerLogo);
            $('.js-featured-modal-heading').html(data.section7.featuredPartnerCard.partnerName);
            $('.js-featured-modal-description').html(data.section7.featuredPartnerCard.longDescription);
            $('.js-featured-modal-cta').attr('href', data.section7.featuredPartnerCard.link);

            // Define Template7 Template HTML
            var compiledPartnersTemplate = Template7.compile(sec7CardsTemplate);
            var sec7CardHtml = compiledPartnersTemplate({"sec7Cards": data.section7.partnerCards});
            $('.js-partners-grid').html(sec7CardHtml);
        }

        if (data.section8) {
            /**
             * Initialize User Generated Content
             * 
             * USE VANILLA JS FOR CROWDRIFF. USING JQUERY COMMANDS WILL BREAK PATHING SCOPE.
             * $('#loaderUGC').append(s);//<--will break
             * loaderUGC.append(s);//<--will also break on IE. use appendChild
             * 
             * @param {*} data 
             * @param {*} divId 
             */
            var initializeUGC = function (data, divId) {
                // if (_log) console.log('initializeUGC');
                // if (_log) console.log('ugc.data:', data);
                //if (_log) console.log('window1:', window);

                if (!initUgc) {
                    //If UGC has been initialized already, clear out the rendered array
                    window.crowdriff__gallery.rendered = [];
                    //if (_log) console.log('window.crowdriff__gallery:', window.crowdriff__gallery);
                }
                $('#' + divId).html('');//clear out div

                var s = document.createElement("script");
                s.type = "text/javascript";
                s.src = "https://starling.crowdriff.com/js/crowdriff.js";
                s.id = data; //"ex: cr-init__1b59e2be8c775f33"
                var loaderUGC = document.getElementById(divId);
                loaderUGC.appendChild(s);
                //if (_log) console.log('appendChild.s:', s);

                if (!initUgc) {
                    //If UGC has been initialized already, restart interval to process Queue
                    //if (_log) console.log('window.crowdriff__gallery.interval:', window.crowdriff__gallery.interval);
                    if (window.crowdriff__gallery && !window.crowdriff__gallery.interval) {
                        window.crowdriff__gallery.interval = setInterval(window.crowdriff__gallery.processQueue, 300);
                    }
                }
                initUgc = false;
            }
            // Inject Copy
            $('.js-ugc-heading').html(data.section8.heading);
            $('.js-ugc-copy').html(data.section8.copy);
            // Initialize UGC
            setTimeout(initializeUGC, 3000, data.section8.crowdRiffId , "photoGallery");
            // initializeUGC(data.section4.crowdRiffId , "photoGallery");
        }

        

        if(data.section9) {
            $('.js-callout-kicker').html(data.section9.kicker);
            $('.js-callout-heading').html(data.section9.heading);
            $('.js-callout-button').attr('href', data.section9.cta.link);
            $('.js-callout-button').html(data.section9.cta.text);
            
            var compiledCalloutImageTemplate = Template7.compile(sec9CalloutImgTemplate);
            var calloutImgHtml = '';
            var calloutJsonContent = {
                calloutImageUrlSmall: data.section9.backgroundImageMobile,
                calloutImageUrlLarge: data.section9.backgroundImageDesktop
            };
            calloutImgHtml += compiledCalloutImageTemplate(calloutJsonContent);
            // if (_log) console.log(calloutJsonContent);
            $('.js-section9').append(calloutImgHtml);
        }

        // if(data.toast) {
        //     $('.js-toast-heading').html(data.toast.heading);
        //     $('.js-toast-description').html(data.toast.description);
        // }
    }

    
	
	$(initializePage);


    setTimeout(() => {
        // Experience Modals
        const videoModalTriggers = document.querySelectorAll(".js-video-modal-trigger");
        const videoModal = document.querySelector(".js-video-modal");
        const videoModalIframe = videoModal.querySelector('.js-video-modal-embed');
        const videoModalCloseBtn = document.querySelector(".js-dialog-close");
        videoModalTriggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                videoModal.showModal();
                videoModalIframe.src = 'https://www.youtube.com/embed/' + trigger.dataset.videoId + '?autoplay=1';
            });
        })
        videoModalCloseBtn.addEventListener("click", () => {
            videoModal.close();
            videoModalIframe.src = '';
        });
        
        // Partner Modals
        const contentModalTriggers = document.querySelectorAll(".js-content-modal-trigger");
        
        contentModalTriggers.forEach((trigger) => {
            trigger.addEventListener("click", (e) => {
                e.preventDefault();
                
                const contentModal = document.querySelector('[data-modal-id="' + trigger.dataset.modalTarget + '"]');
                const closeButton = contentModal.querySelector('.js-content-dialog-close');

                //For Partner CTA Click tracking
                if (_log) console.log('partnerName', trigger.dataset.partnerName);
                tw.Analytics.ga4(baseCategory, 'Partner CTA Click', trigger.dataset.partnerName);

                // const closeButton = 
                contentModal.showModal();
                closeButton.addEventListener("click", () => {
                    contentModal.close();
                });
            });
        }) 
    }, 1000);
    
    
    // setTimeout(() => {
    //     // Toast

    //     $('.js-toast-close').on('click', function () {
    //         $('.js-culinary-toast').remove();
    //         $.cookie('HideCulinaryToast', 'true');
    //     });

    //     if (!!$.cookie('HideCulinaryToast')) {
    //     } else {
    //         $('.js-culinary-toast').removeClass('d-none');
    //     }        
    // }, 80000);  // 1 minute 20 seconds
    

	return {
		initializePage: initializePage,
		initializeMap: initializeMap,
		openSubpane: openSubpane,
		closeSubpanes: closeSubpanes,
        resetAllPanes: resetAllPanes,   
	}
}());